import { SuburbanFacilitiesContainer } from '../../containers/advancedFilters/SuburbanFacilitiesContainer';
import { IFilter } from '../../types/advancedFilters';

export const suburbanFacilities: IFilter = {
  component: SuburbanFacilitiesContainer,
};
